export var Currency;
(function (Currency) {
    Currency["UAH"] = "UAH";
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
})(Currency || (Currency = {}));
export var Period;
(function (Period) {
    Period["MONTH"] = "month";
    Period["YEAR"] = "year";
})(Period || (Period = {}));
export var SubscriptionName;
(function (SubscriptionName) {
    SubscriptionName["Trial"] = "trial";
    SubscriptionName["Business"] = "business";
})(SubscriptionName || (SubscriptionName = {}));
